<template>
  <div
    class="roulette-card"
    @click="$emit('cardSelected', { id, branch })"
    style="touch-action: none;"
    :style="cardComponentStyle"
  >
    <div class="card-number-column">
      <div v-if="numerated" class="number-area">{{ index }}</div>
      <div v-else class="number-area">
        <object
          type="image/svg+xml"
          class="svg-image"
          :data="getCardImageSrc('icon')"
        >
        </object>
      </div>
    </div>
    <div class="card-content-column">
      <div v-if="withImages" class="image-area">
        <object
          :id="'svgObject' + id"
          type="image/svg+xml"
          class="svg-image"
          :data="getCardImageSrc(id)"
        >
        </object>
      </div>
      
      <div class="title-area">
        <p>{{ cardTextLines(id)[0] }}</p>
        <p>{{ cardTextLines(id)[1] }}</p>
        <p>{{ cardTextLines(id)[2] }}</p>
      </div>
    </div>
    <div id="info">
      <a @click="showOptionInfo">
        <i class="mdi mdi-information-outline"></i>
      </a>
    </div>
  </div>
</template>

<script>
import NotificationModal from '@/components/on-board/NotificationModal'

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    colorWhite: {
      type: String,
      default: 'white'
    },
    colorFilterValues: {
      type: Object,
      default() {
        return {
          invert: '79',
          sepia: '28',
          saturate: '3435',
          hueRotate: '1',
          brightness: '106',
          contrast: '103'
        }
      }
    },
    colorTexto: {
      type: String
    },
    branch: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    helpKey: {
      required: true
    },
    numerated: {
      type: Boolean,
      required: true
    },
    withImages: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    cardComponentStyle: function() {
      return {
        '--filter-color': this.getColorFilter(),
        '--color': this.colorTexto,
        '--white': this.colorWhite,
        '--border-color': this.color
      }
    }
  },
  methods: {
    getColorFilter() {
      return `invert(${this.colorFilterValues.invert}%) sepia(${this.colorFilterValues.sepia}%) saturate(${this.colorFilterValues.saturate}%) hue-rotate(${this.colorFilterValues.hueRotate}deg) brightness(${this.colorFilterValues.brightness}%) contrast(${this.colorFilterValues.contrast}%)`
    },
    cardTextLines(textKey) {
      const splittedTranslation = this.$t(textKey).split('#')
      let translationParts = ['', '', '']
      splittedTranslation.forEach((element, index) => {
        translationParts[index] = element
      })

      return translationParts
    },
    showOptionInfo: function(event) {
      let self = this
      const helpKey = self.helpKey ? self.helpKey : 'GENERICH'
      event.stopPropagation()
      self.$dlg.modal(NotificationModal, {
        height: 600,
        shaking: false,
        title: false,
        params: {
          title: self.$t(self.id),
          bgColor: self.$route.meta.extra.colors.helpModal,
          content: self.$t(helpKey),
          confirmText: this.$t('Cerrar'),
          closeText: this.$t('Cerrar')
        }
      })
    },
    getCardImageSrc: function(id) {
      return require('@/assets/roulette_card_images/' +
        this.type +
        '/' +
        id +
        '.svg')
    }
  }
}
</script>

<style scoped>
.svg-image {
  filter: var(--filter-color);
}

.card-number-column,
.card-content-column {
  background: var(--white);
  color: var(--color);
  border: solid;
  border-width: 4px;
  border-color: var(--border-color);
}

#info i {
  color: var(--color);
}

.roulette-card:hover #info i {
  color: var(--white);
}

.roulette-card:hover .svg-image {
  filter: invert(99%) sepia(16%) saturate(0%) hue-rotate(263deg)
    brightness(109%) contrast(100%);
}

.roulette-card:hover .card-number-column,
.roulette-card:hover .card-content-column {
  background: var(--color);
  border-color: var(--white);
  color: var(--white);
}
</style>
<style lang="scss">
.hooper-slide {
  transition: 0.3s;
}
.hooper-slide:hover {
  transform: scale(1.01);
  transition: 0.3s;
}
.roulette-card {
  position: relative;
  height: 100%;
  transition: 0.3s;
}
.roulette-card:hover {
  cursor: pointer;
}

.card-svg {
  position: absolute;
  z-index: -1;
}
// Circulo svg tarxeta - Svg card circle
.cls-2 {
  fill: url(#linear-gradient);
}
.card-number-column {
  position: absolute;
  display: flex;
  font-size: 50px;
  text-align: center;
  width: 85px;
  height: 85px;
  color: #fafafa;
  border-radius: 50%;
  border: solid lightgray 5px;
  z-index: 2;

  div {
    margin: auto;
    display: flex;
    pointer-events: none;
  }
}
.card-content-column {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  border-radius: 40% 10px 10px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  .title-area {
    font-weight: bold;
    max-width: 70%;
    min-width: 53%;
    font-size: 19px;
    line-height: 1em;
    text-align: center;
    align-content: center;
    margin: auto 5px;
    
    /*text-shadow: 0 0 5px rgba(0, 0, 0, 0.3); */
  }
  .image-area {
    height: 50%;
    min-height: 100px;
    padding: 10px;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    object {
      height: 100%;
      pointer-events: none;
    }
  }
}
.card-content-column:hover {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
}
#info a {
  position: absolute;
  left: 17px;
  bottom: 10px;
  font-size: 50px;

  &:hover {
    text-shadow: 0 0 10px white;
    transition: 0.3s;
  }
}
// EFECTOS ESPECIALES
.card-number-column,
.card-content-column {
  transition: 0.3s;
}

.roulette-card:hover .card-number-column,
.roulette-card:hover .card-content-column {
  animation-name: rouleteShadows;
}
</style>
